import React from 'react';
import { BannerEditor } from './components/BannerEditor/BannerEditor';

const App: React.FC = () => {
  return (
    <div className="app-root" style={{ width: '100%', height: '100%', display: 'flex' }}>
      <BannerEditor />
    </div>
  );
};

export default App;


